import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Heading,
  Text,
  useToast,
} from '@chakra-ui/react';
import supabase from '../utils/supabaseUtils';
import { getOrCreateAppUser } from '../utils/supabaseUtils';
import { recordLogin } from '../utils/loginTracker';

const LocalSignup = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
      });
      if (error) throw error;

      // Create app_users row immediately (no email confirmation in local dev)
      await getOrCreateAppUser();
      await recordLogin(data.user.id);

      toast({ title: 'Account created', status: 'success' });
      navigate('/dashboard');
    } catch (err) {
      console.error(err);
      toast({ title: 'Signup failed', description: err.message, status: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxW="md" py={10}>
      <VStack spacing={6} as="form" onSubmit={handleSubmit} align="stretch">
        <Heading size="lg" textAlign="center">Local Sign Up</Heading>
        <FormControl isRequired>
          <FormLabel>Email</FormLabel>
          <Input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Password</FormLabel>
          <Input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} />
        </FormControl>
        <Button type="submit" colorScheme="blue" isLoading={loading}>Create Account</Button>
        <Text fontSize="sm" color="gray.500">This form is intended for local development only.</Text>
      </VStack>
    </Container>
  );
};

export default LocalSignup; 